var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.074,
    y: 4.70056,
    width: 3.51594,
    height: 16.0214,
    rx: 1.75797,
    transform: "rotate(-30 14.074 4.70056)",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1331 13.1125L3.57946 15.1642C2.62288 15.7165 2.29513 16.9396 2.84741 17.8962L5.04349 21.7C5.59578 22.6565 6.81896 22.9843 7.77554 22.432L11.3292 20.3803",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6687 20.7618C14.0062 18.8349 17.7752 17.7796 21.628 17.6934L22.1052 17.6827",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13306 13.1125C9.96795 11.4758 12.3543 9.16372 14.08 6.38204L14.8572 5.12918",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08724 21.9704L11.8836 28.0279C12.3532 28.7771 13.2721 29.1111 14.1131 28.8382C15.3128 28.4491 15.8223 27.0322 15.1452 25.9682L11.7346 20.608",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7453 12.6883C24.3248 11.7765 24.8793 9.77994 23.9838 8.229C23.0884 6.67806 21.0821 6.16001 19.5027 7.0719L22.7453 12.6883Z",
    stroke: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91609 18.1899L1.87555 18.7907C1.39725 19.0668 1.23338 19.6784 1.50952 20.1567L2.57424 22.0009C2.85039 22.4792 3.46198 22.643 3.94027 22.3669L4.98081 21.7661",
    stroke: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.5779L12.5 20.5779",
    stroke: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10.0779L31 11.0779",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3799 4.66403L26.1019 0.500143",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7388 6.92792L30.669 4.99694",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.2961d0abc91cb9d100f40107993a0f19.svg";
export { ForwardRef as ReactComponent };